import script from "./CardProdCollec.vue?vue&type=script&setup=true&lang=js"
export * from "./CardProdCollec.vue?vue&type=script&setup=true&lang=js"

import "./CardProdCollec.vue?vue&type=style&index=0&id=53bc5002&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bc5002"]])

export default __exports__